<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-plan-pago-universidad-concepto-universidad"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :rowDragManaged="true"
      :suppressMoveWhenRowDragging="true"
      @row-drag-end="onRowDragEnd">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererSiONo, formatearValorAMoneda, valueFormatterMoneda } from '../utils/funciones';

export default {
  name: 'ListadoPlanesPagosConceptosUniversidades',
  mixins: [listadoAgGridMixin],
  props: {
    filasArrastrables: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rowClassRules: {
        desactivado: (params) => !params.data.estaActivo,
      },
      columnDefs: [
        {
          headerName: 'CONCEPTO',
          field: 'conceptoUniversidad.concepto.nombre',
          minWidth: 300,
          rowDrag: this.filasArrastrables,
        },
        {
          headerName: 'ESTA ACTIVO',
          cellRenderer: cellRendererSiONo('estaActivo', 'SI', 'NO'),
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'ORDEN',
          field: 'orden',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'N° CUOTAS',
          field: 'numeroCuotas',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'MONTO TOTAL',
          field: 'montoTotal',
          type: 'numericColumn',
          valueFormatter: valueFormatterMoneda,
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'PORCENTAJE',
          field: 'porcentaje',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'MONTO',
          field: 'monto',
          type: 'numericColumn',
          valueFormatter: valueFormatterMoneda,
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'DETALLES PLANES PAGOS CONCEPTOS UNIVERSIDADES',
          autoHeight: true,
          minWidth: 300,
          maxWidth: 300,
          filter: false,
          headerComponentParams: {
            template: /* html*/ `
            <table width="100%" style="border-collapse">
              <thead>
                <tr>
                  <th style="font-size: 12px; font-weight: 600; width: 100px; padding-left: 10px; padding-right: 10px;">N° DE CUOTA</th>
                  <th style="font-size: 12px; font-weight: 600; width: 200px; padding-left: 10px; padding-right: 10px; border-left: 1px solid #cecece;">MONTO</th>
                </tr>
              </thead>
            </table>`,
          },
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            } else {
              let detalle = /* html*/ `

              <table width="100%" style="border-collapse: collapse;">
                <tbody>`;

              params.data.detallesPlanesPagosConceptosUniversidades.forEach((detallePlanPago) => {
                detalle += /* html*/ `
                <tr>
                  <td style="font-size: 13px; width: 100px; padding-left: 10px; padding-right: 10px; text-align: right;">${
                    detallePlanPago.numeroCuota
                  }</td>
                  <td style="font-size: 13px; width: 200px; padding-left: 10px; padding-right: 10px; text-align: right;">${formatearValorAMoneda(
                    detallePlanPago.monto,
                  )}</td>
                </tr>`;
              });

              detalle += /* html*/ `
                </tbody>
              </table>`;

              return detalle;
            }
          },
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizadoEn',
          filter: false,
          minWidth: 200,
        },
      ],
    };
  },
  methods: {
    onRowDragEnd(e) {
      e.api.forEachNode((rowNode) => {
        rowNode.setDataValue('orden', rowNode.rowIndex + 1);
      });

      this.$emit('ordenar');
    },
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-plan-pago-universidad-concepto-universidad {
  height: calc(var(--vh, 1vh) * 100 - 23.5rem);
}

.ag-theme-balham .desactivado {
  background-color: #f8d7da !important;
  color: #721c24 !important;
}
</style>
  